module.exports = __webpack_public_path__ + "static/media/67563735_2017782521658904_3460521872704143360_o.9d978335.png";